import requester from '@/lib/axios';
import JsonApiResponse from '@/models/JsonApiResponse';
import LessonProgressDashboard from '@/models/LessonProgressDashboardStats';
import { dashboardPath } from './studentDashboardStatsServices';
import { LessonProgressFilters } from './lessonProgressServices';

const lessonProgressPath = 'lesson-progress';

export type DashboardLessonProgressFilters = LessonProgressFilters;
export async function listDashboardLessonProgress(
  params?: DashboardLessonProgressFilters,
) {
  const { data } = await requester().get<
    JsonApiResponse<LessonProgressDashboard>
  >(`${lessonProgressPath}/${dashboardPath}/`, {
    params,
  });

  return data;
}
